import type { RowComponentProps } from 'react-window';

import type { RenderItemFn } from '../types';

export type RowProps<ItemProps = any> = {
  data: Array<Omit<ItemProps, 'index'>>;
  renderItem: RenderItemFn<ItemProps>;
};

export const RowComponent = ({ index, style, data, renderItem }: RowComponentProps<RowProps>) => {
  const itemProps = data[index];

  return (
    <div className="overflow-y-auto" style={style}>
      {renderItem({ index, ...itemProps })}
    </div>
  );
};
